import { useTranslation } from 'react-i18next';
import { Button, Typography } from 'mobily-ui-library';

import './StickyPriceBar.scss';

interface Props {
    rtl: boolean;
    orderPriceData: any
    handleCheckout: () => void
    handleContinue?: () => void;
    checkOutOfStock: boolean
    isFindInBranch?: boolean;
    checkoutDisabled?: boolean;
}

function StickyPriceBar({ rtl, orderPriceData, handleCheckout, handleContinue, checkOutOfStock, isFindInBranch, checkoutDisabled }: Props) {
    const { t } = useTranslation();

 const onButtonClick = () => {
        if (isFindInBranch) {
            handleContinue?.(); // optional chaining, safe if undefined
        } else {
            handleCheckout();
        }
    };

    return (
        <div className={rtl ? 'CartPage__StickyPriceBar CPSB__Right' : 'CartPage__StickyPriceBar'}>
            <div className='SPB__Container'>
                <div className='SPB__PriceButton'>
                    <div className='SPB__Total'>
                        <Typography rtl={rtl} className='SPB__CartText'>{t("Cart_total")}</Typography>
                        <Typography rtl={rtl} className='SPB__Price'>
                            <span>{t("SAR")}&nbsp;</span>
                            {orderPriceData?.cartTotalPrice?.[0].price?.taxIncludedAlteredAmount?.value} 
                        </Typography>
                    </div>
                    <Button
                        rtl={rtl}
                        className='SPB__Button'
                        onClick={onButtonClick}
                        variant={checkOutOfStock || checkoutDisabled ? 'disabled' : 'default'}
                    >
                        {checkOutOfStock
                            ? t("Sold_out")
                            :   t("Continue")
                                }
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default StickyPriceBar;